import type { PostHog } from 'posthog-js'

// posthog-js laadt als losse chunk zodat hij de hydration niet ophoudt.
// `$posthog()` is undefined tot hij geladen is; wacht op `$posthogReady` als je hem nodig hebt.
export default defineNuxtPlugin((nuxtApp) => {
  const runtimeConfig = useRuntimeConfig()
  let client: PostHog | undefined

  const ready = import('posthog-js').then(({ default: posthog }) => {
    client = posthog.init(runtimeConfig.public.posthogPublicKey, {
      api_host: runtimeConfig.public.posthogHost,
      defaults: '2025-05-24',
      disable_surveys: true,
    })

    // Superproperty op elk event: zonder dit kan een gedeeld overzicht de twee
    // sites (huisassist.nl en juistemakelaar.nl) niet uit elkaar houden.
    client.register({ site: 'juistemakelaar' })
    return client
  })

  nuxtApp.hook('vue:error', (error) => {
    ready.then(ph => ph.captureException(error))
  })

  return {
    provide: {
      posthog: () => client,
      posthogReady: ready,
    },
  }
})
